import { IonCol, IonRow } from "@ionic/react";
import React, { useEffect, useState } from "react";
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	Line,
	LineChart,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import Spacer from "../../../../components/spacer";
import CustomTooltip from "./components/CustomTooltip";
import { prepareIndependenceGraph, prepareVoidsGraph } from "./utils";

interface props {
	entries: any;
	labels: any;
}

const ChartsToileting: React.FC<props> = ({ entries, labels }) => {
	const [voidGraph, setVoidGraph] = useState<any>({});
	const [indepGraph, setIndepGraph] = useState<any>({});

	useEffect(() => {
		if (entries) {
			prepareGraphData();
		}
	}, [entries]);

	const prepareGraphData = () => {
		// console.log(entries);
		setVoidGraph(prepareVoidsGraph(entries));
		setIndepGraph(prepareIndependenceGraph(entries));
	};

	return (
		<>
			<IonRow>
				<IonCol>
					<Spacer size="30" />
					<div>
						<h2 className="chart-title">Frequency of Voids & Accidents</h2>
						<ResponsiveContainer
							width="100%"
							height="100%"
							minWidth="300px"
							minHeight="300px"
						>
							<LineChart
								width={600}
								height={600}
								data={voidGraph}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="name" />
								<YAxis />
								<Tooltip
									content={
										<CustomTooltip
											active={""}
											payload={""}
											label={""}
											labels={labels}
										/>
									}
								/>
								<Legend />
								<Line type="monotone" dataKey="voids" stroke="#8884d8" />
								<Line type="monotone" dataKey="accidents" stroke="#82ca9d" />
							</LineChart>
						</ResponsiveContainer>
					</div>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol>
					<Spacer size="30" />
					<div>
						<h2 className="chart-title">
							Percentage of steps completed independently
						</h2>
						<ResponsiveContainer
							width="100%"
							height="100%"
							minWidth="300px"
							minHeight="300px"
						>
							<BarChart
								width={600}
								height={600}
								data={indepGraph}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="name" />
								<YAxis />
								<Tooltip
									content={
										<CustomTooltip
											active={""}
											payload={""}
											label={""}
											labels={labels}
										/>
									}
								/>
								<Legend
									margin={{
										top: 10,
										right: 30,
										left: 20,
										bottom: 5,
									}}
								/>
								<Bar dataKey="independence" barSize={20} fill="#8884d8" />
							</BarChart>
						</ResponsiveContainer>
					</div>
				</IonCol>
			</IonRow>
		</>
	);
};

export default ChartsToileting;

